import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from "../../core/_services/utilities.service";
import {Contact} from '../_models/contact';

@Pipe({
    name: 'contactDisplay'
})
export class ContactDisplayPipe implements PipeTransform {

    transform(contact: Contact): string {
        // require firstName, lastName, email, phone
        if (UtilitiesService.isEmpty(contact)
            || !contact.firstName
            || !contact.lastName
            || !contact.email
            || !contact.phone) {
            return '';
        }

        return `${contact.firstName} ${contact.lastName} - ${contact.email} - ${contact.phone}`;
    } // transform()

} // ContactDisplayPipe
